import React from 'react';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip as ChartTooltip, XAxis, YAxis } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import { cycleTimes } from '../../data/analytics';
export function CycleTimeChart() {
  const overruns = cycleTimes.filter(entry => entry.meanDays > entry.targetDays);
  return <SectionCard title="Stage cycle time" description="Mean days in stage against the service target, across closed and live records" data-id="element-365" data-mp="er4nv5tofo0s">
      <div className="h-64 w-full" data-id="element-366" data-mp="9tbj8h80v22m">
        <ResponsiveContainer width="100%" height="100%" data-id="element-367" data-mp="9q79l4bsfe4k">
          <BarChart data={cycleTimes} layout="vertical" margin={{
          top: 4,
          right: 16,
          left: 30,
          bottom: 0
        }} data-id="element-368" data-mp="5p3reb69p606">
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" horizontal={false} data-id="element-369" data-mp="2qge2ci8xoisu" />
            <XAxis type="number" tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={false} unit="d" data-id="element-370" data-mp="2lhknale00jqk" />
            <YAxis type="category" dataKey="stage" width={100} tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={false} data-id="element-371" data-mp="3hse1rnzgvl4r" />
            <ChartTooltip contentStyle={{
            fontSize: 12,
            borderRadius: 4,
            border: '1px solid var(--border)'
          }} formatter={(value: number) => `${value} days`} data-id="element-372" data-mp="38pczjydq2e6d" />
            <Legend wrapperStyle={{
            fontSize: 11
          }} data-id="element-373" data-mp="2yub98z7pn627" />
            <Bar dataKey="meanDays" name="Mean days" fill="var(--chart-1)" radius={[0, 2, 2, 0]} data-id="element-374" data-mp="2l2ek941c9ca1" />
            <Bar dataKey="targetDays" name="Target" fill="var(--chart-3)" radius={[0, 2, 2, 0]} data-id="element-375" data-mp="2p2f9zktw19we" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <p className="mt-2 text-[11px] leading-relaxed text-muted-foreground" data-id="element-376" data-mp="2b5rzef90il80">
        {overruns.length} of {cycleTimes.length} stages run over target. The largest relative
        overrun is {overruns[0]?.stage ?? '—'} at{' '}
        {overruns[0] ? overruns[0].meanDays - overruns[0].targetDays : 0} days above the service
        standard.
      </p>
    </SectionCard>;
}